module.exports = __webpack_public_path__ + "static/img/campaigns.5939be2d.svg";